import * as classnames from 'classnames';
import * as React from 'react';

import { Collapse } from 'components/Collapse';

import './Accordion.scss';

interface AccordionProps {
  id?: string;
  isOpen?: boolean;
  modifier?: 'with-header-top-border';
  onClick?: () => void;
  title: string | JSX.Element;
}

interface AccordionState {
  isOpen: boolean;
}

export class Accordion extends React.Component<AccordionProps, AccordionState> {
  constructor(props: AccordionProps) {
    super(props);

    this.state = { isOpen: props.isOpen || false };
    this.toggleAccordion = this.toggleAccordion.bind(this);
  }

  render() {
    const { children, id, modifier, title } = this.props;
    const classNameHeaderContainer = modifier && 'accordion__header--' + modifier;
    const classNameIconContainer = modifier && 'accordion__icon--' + modifier;
    const classNameIcon = this.state.isOpen ? 'ic-arrow-top' : 'ic-arrow-down';

    return (
      <div id={id}>
        <div className={classnames('accordion__header', classNameHeaderContainer)} onClick={this.toggleAccordion}>
          <div className="accordion__title">{title}</div>
          <div className={classnames('accordion__icon', classNameIconContainer)}>
            <i className={classNameIcon}/>
          </div>
        </div>
        <Collapse isOpen={this.state.isOpen}>
          {children}
        </Collapse>
      </div>
    );
  }

  private toggleAccordion() {
    const { onClick } = this.props;
    if (onClick) {
      onClick();
    }

    this.setState({ isOpen : !this.state.isOpen });
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Accordion/Accordion.tsx